import _ from "./ObjectUtils";
import regex from "./regex";

let Validators = {

    email(value) {
        return _.isNilOrEmpty(value) || (!_.isNilOrEmpty(value) && regex.email.test(value));
    },

    password(value) {
        return !_.isNilOrEmpty(value) && regex.password.test(value);
    },

    passwordLength(value) {
        return !_.isNilOrEmpty(value) && !regex.passwordLength.test(value);
    },

    isInteger(value) {
        return regex.numeric.test(value);
    },

    isUrl(value) {
        return regex.url.test(value);
    },

    isConsolePin(value) {
        return value.length === 4 && regex.numeric.test(value);
    },

    isLatitude(value) {
        return regex.latitude.test(value);
    },

    isLongitude(value) {
        return regex.longitude.test(value);
    },

    hasSpecialCharacters(value) {
        return regex.noSpecialCharacters.test(value);
    }
};

export default Validators;